export default "__VITE_ASSET__DjE$_x_4__"